import type { CostBreakdownLine, CostLineKind } from "@/lib/personnelCostCalc";
import { formatEuro } from "@/lib/personnelCosts";

const BAR_COLORS: Record<CostLineKind, string> = {
  gross: "bg-accent",
  percent: "bg-emerald-500",
  fixed_employee: "bg-amber-500",
  fixed_global: "bg-violet-500",
  fixed_department: "bg-sky-500",
  hourly: "bg-rose-500",
};

interface CostWaterfallProps {
  lines: CostBreakdownLine[];
  totalMonthly: number;
  compact?: boolean;
}

export function CostWaterfall({ lines, totalMonthly, compact = false }: CostWaterfallProps) {
  const max = Math.max(totalMonthly, ...lines.map((l) => l.amountMonthly), 1);

  return (
    <div className={compact ? "space-y-1.5" : "space-y-2"}>
      {lines.map((line) => {
        const widthPct = line.amountMonthly > 0 ? Math.max(2, (line.amountMonthly / max) * 100) : 0;
        return (
          <div key={`${line.kind}-${line.label}`} className="space-y-1">
            <div className="flex items-center justify-between gap-3 text-sm">
              <span className={compact ? "text-label-secondary" : "text-label"}>{line.label}</span>
              <span className="shrink-0 tabular-nums font-medium text-label">
                {formatEuro(line.amountMonthly)}
              </span>
            </div>
            <div className="h-2.5 overflow-hidden rounded-full bg-fill-secondary">
              <div
                className={`h-full rounded-full transition-all ${BAR_COLORS[line.kind]}`}
                style={{ width: `${Math.min(100, widthPct)}%` }}
              />
            </div>
          </div>
        );
      })}
      <div
        className={`flex items-center justify-between border-t border-separator font-semibold ${
          compact ? "pt-2 text-xs" : "pt-3 text-sm"
        }`}
      >
        <span>Gesamtkosten/Monat</span>
        <span className="tabular-nums">{formatEuro(totalMonthly)}</span>
      </div>
    </div>
  );
}
